define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Address = (function () {
        function Address() {
            this.City = null;
            this.Street = null;
            this.Zip = null;
            this.Street2 = null;
            this.Comment = null;
            this.Country = null;
        }
        return Address;
    }());
    exports.Address = Address;
});
//# sourceMappingURL=Address.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Address.js
// module id = 147
// module chunks = 0